/**
* 头部菜单
*/
<template>
  <div>
    <el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" text-color="#fff"
             active-text-color="#fff">
      <el-button class="buttonimg">
        <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
      </el-button>
      <el-submenu index="1" class="submenu">
        <template slot="title">{{ user.username }}</template>
        <el-menu-item @click="passwordEdit()" index="2-2">修改密码</el-menu-item>
        <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
      </el-submenu>
      <el-menu-item index="2" class="submenu" @click="toMsg">
        <i class="el-icon-s-comment"></i>消息通知({{ messageCount }})
      </el-menu-item>
    </el-menu>

    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input size="small" v-model="editForm.oldPassword" auto-complete="off" placeholder="请输入旧密码"
                    show-password/>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input size="small" v-model="editForm.password" auto-complete="off" placeholder="请输入密码"
                    show-password/>
        </el-form-item>
        <el-form-item label="确认密码" prop="certPassword">
          <el-input size="small" v-model="editForm.certPassword" auto-complete="off" placeholder="请输入确认密码"
                    show-password/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="changPassword">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {loginout, userEdit, updatePassword} from '../api/userMG'
import {myMsgCount} from '../api/commonMsgMG'

export default {
  name: 'navcon',
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
        // password 是表单上绑定的字段
      } else if (value !== this.editForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      messageCount: 0,  //消息通知数量
      collapsed: true,
      editFormVisible: false, //控制编辑页面显示与隐藏
      loading: false, //是显示加载
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      title: '修改密码',
      user: {},
      editForm: {
        oldPassword: '',
        password: '',
        certPassword: ''
      },
      rules: {
        oldPassword: [
          {required: true, message: '请输入旧密码', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ],
        certPassword: [
          {required: true, validator: validatePass2, trigger: 'blur'}
        ]
      },
      resetpsd: {
        id: '',
        password: '',
        token: localStorage.getItem('logintoken')
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
    this.getUserMsgCount()
  },
  methods: {
    //获取用户未读消息说明
    getUserMsgCount() {
      myMsgCount().then(res => {
        if (res.code != 0) {
          this.$message({type: 'info', message: res.msg})
        } else {
          this.messageCount = res.data;
        }
      })
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setTimeout(() => {
          this.$store.commit('logout', 'false')
          this.$router.push({path: '/login'})
          this.$message({type: 'success', message: '已退出登录!'})
        }, 1000)
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    },
    //确认修改密码
    changPassword: function () {
      this.$refs['editForm'].validate(valid => {
        if (valid) {
          this.loading = true
          let params = {
            'oldPassword': this.editForm.oldPassword,
            'newPassword': this.editForm.password
          };
          updatePassword(params).then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({type: 'info', message: res.msg})
            } else {
              this.closeDialog('edit')
              setTimeout(() => {
                this.$message({type: 'success', message: '修改密码成功,请重新登录!'})
                this.$store.commit('logout', 'false')
                this.$router.push({path: '/login'})
              }, 1000)
            }
          })
        }
      })
    },
    //显示密码修改框
    passwordEdit() {
      this.editFormVisible = true
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      this.$refs['editForm'].resetFields()
      if (dialog == 'edit') {
        this.editFormVisible = false
      }
    },
    //进入消息管理界面
    toMsg() {
      let url = "/commonMsg/commonMsg";
      if (this.$route.path !== url) {
        this.$router.push({path: url})
      }
    }
  }
}
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}

.submenu {
  float: right;
}

.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}

.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}

.showimg:active {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue